import { Component, EventEmitter, Input, Output } from '@angular/core';
import { stringBuilder } from '../../shared/utils/string-builder';
import { ModelAttributeGridListConfig } from './model-attribute-grid-list.constants';

@Component({
  selector: 'model-attribute-grid-list',
  templateUrl: './model-attribute-grid-list.component.html',
  styleUrls: ['./model-attribute-grid-list.component.scss'],
})
export class ModelAttributeGridListComponent {
  @Input() config: ModelAttributeGridListConfig;
  @Input() items: any[];

  @Output() edit = new EventEmitter();
  @Output() delete = new EventEmitter();

  public onEdit(item, index) {
    if (!this.config.canEdit) {
      return;
    }
    item.index = index;
    this.edit.emit(item);
  }

  public onDelete(item, index) {
    if (!this.config.canDelete) {
      return;
    }
    item.index = index;
    this.delete.emit(item);
  }

  public getItemLabel(config, item): string {
    if (config && item) {
      return stringBuilder(config, item);
    }

    return '';
  }
}
